import { HttpClientInterface } from 'src/network/HttpClientInterface'
import { TranscriptOld } from 'src/models/TranscriptOld'
import { TranscriptMetadata } from 'src/models/TranscriptMetadata'
import { UserRole } from 'src/models/User'
import { MediaDescriptor } from 'src/models/Media'
import { getViewMode } from 'src/utils/env'

export class MockHttpClient implements HttpClientInterface {
    async getTranscript(): Promise<TranscriptOld> {
        await document.mocks.isReady()

        return this.hydrateTranscript(document.mocks.getInitialTranscript())
    }

    async getTranscriptMetadata(): Promise<TranscriptMetadata> {
        await document.mocks.isReady()

        return this.hydrateMetadata(document.mocks.getTranscriptMetadata())
    }

    async getMedia(): Promise<MediaDescriptor> {
        return {
            isHls: false,
            mediaUrl: 'https://example.com/media.mp4',
        }
    }

    async identify() {
        await document.mocks.isReady()

        if (document.mocks.isAnonymousUser()) {
            throw new Error('No user')
        } else {
            return {
                email: 'user@mail.com',
                rules: ['customer_admin'] as UserRole[],
                companyName: 'company',
                customerId: null,
                userName: 'Guest',
                userId: 1337,
            }
        }
    }

    private hydrateMetadata(metadata: TranscriptMetadata) {
        if (metadata.sessionState?.startTime) {
            metadata.sessionState.startTime = new Date(metadata.sessionState.startTime)
        }

        metadata.viewMode = getViewMode()

        return metadata
    }

    private hydrateTranscript(transcript: TranscriptOld) {
        transcript.recordingStartedAt = new Date(transcript.recordingStartedAt)

        return transcript
    }
}
